var _defs, _circle, _circle2, _g, _g2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigaAppUnbelsouvenir3StelleColoreMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0_souvenir_3min {\n        fill: none;\n      }\n\n      .st1_souvenir_3min {\n        fill: #eee0bb;\n      }\n\n      .st2_souvenir_3min {\n        fill: #ec7703;\n      }\n\n      .st3_souvenir_3min {\n        clip-path: url(#clippath_souvenir_3min);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath_souvenir_3min"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0_souvenir_3min",
    cx: 70.8,
    cy: 48.4,
    r: 43.4
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1_souvenir_3min",
    cx: 70.8,
    cy: 48.4,
    r: 48.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2_souvenir_3min",
    cx: 70.8,
    cy: 48.4,
    r: 45.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3_souvenir_3min"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1_souvenir_3min",
    d: "M24.5,21c3.1-.6,7.9-1.5,8.1-1.6.3,0,4.3-.2,6.8-.3l21.4,6.9-32.2,45.3-9.1-22.4,4.9-27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_souvenir_3min",
    d: "M30.6,83.9c.3-2.7,1-7.9,1-8.2,0-.3,1.1-4.2,1.8-6.6l13.2-18.3,33.1,44.6-24.1,1.7-24.9-13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_souvenir_3min",
    d: "M88.8,9.3c-.9-2.3-2.3-6.1-2.4-6.4-.2-.2-2.5-4.5-4.1-7.2L54.4-.4l-18.5,15.6,53,16.6V9.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2_souvenir_3min",
    points: "80.9 27 76.8 21.7 70.5 23.9 74.3 18.4 70.3 13 76.7 15 80.6 9.4 80.7 16.2 87.1 18.1 80.8 20.3 80.9 27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_souvenir_3min",
    d: "M112,17.6l-20.5-12.8.5,55.5,21.4-7c2-1.6,5.1-4,5.3-4.3.2-.2,3.5-3.8,5.6-6.1l-12.3-25.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2_souvenir_3min",
    points: "104.6 54.7 100.6 49.3 94.2 51.5 98.1 46 94 40.7 100.4 42.6 104.3 37.1 104.4 43.8 110.9 45.8 104.5 48 104.6 54.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1_souvenir_3min",
    d: "M65.8,72.1l13.3,18.2c2.1,1.4,5.4,3.6,5.7,3.7.3,0,4.6,2.1,7.5,3.5l20.3-19.6,5.8-23.5-52.7,17.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2_souvenir_3min",
    points: "85.7 85.8 81.6 80.5 75.3 82.7 79.1 77.1 75 71.8 81.5 73.7 85.3 68.2 85.4 74.9 91.9 76.9 85.5 79.1 85.7 85.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2_souvenir_3min",
    d: "M70.9,99.3c-10.6,0-20.5-3.3-28.7-8.8l-1.3,4.9-8.3,30.6,17.8-7.8,9.5,22.5,10.2-37.3,1.1-4.1c0,0-.2,0-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2_souvenir_3min",
    d: "M102.2,88.4c-8,6.3-17.8,10.2-28.6,10.8l13.5,42.5,8.7-23.2,18.1,6.4-10-31.4-1.6-5.1Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1_souvenir_3min",
    points: "62.5 36.3 67.4 36.3 64.8 53.9 70.5 53.9 69.8 58.3 59.3 58.3 62.5 36.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1_souvenir_3min",
    points: "82.1 58.3 71.6 58.3 74.8 36.3 79.7 36.3 77.1 53.9 82.8 53.9 82.1 58.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigaAppUnbelsouvenir3StelleColoreMin);
export default __webpack_public_path__ + "static/media/LIGA_APP_unbelsouvenir_3_stelle_colore_min.0c23e4031b4c1ae44fdd9b9ef71b4238.svg";
export { ForwardRef as ReactComponent };